// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2TUle","head":"ProcedureTableInfo_head__bn3aL"};